<template>
  <page>
    <template slot="title">Вакансии</template>
    <template slot="section">
      <columns>
        <column size="10">
          <p>Наша компания заинтересована в притоке высококвалифицированных специалистов. Развитие кадрового потенциалы является одной из приоритетных задач нашей компании. Со своей стороны мы предлагаем:</p>
          <ul>
            <li>высокий уровень заработной платы (обсуждаем по результатам собеседования).</li>
            <li>­оформление по ТК РФ, график работы: свободный, ненормируемый (возможна удаленная работа).</li>
            <li>­широкие перспективы профессиональной самореализации.</li>
            <li>­открытость к Вашим идеям по развитию и поддержку в их реализации.</li>
          </ul>
        </column>
      </columns>
      <columns>
        <column size="10">
          <heading>Открытые вакансии:</heading>
          <ul>
            <li v-for="(vacancy, index) in allVacancies" :key="index">
              <vacancy :vacancy="vacancy"/>
            </li>
          </ul>
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-06.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Heading from '@/components/Heading';
import Page from '@/components/Page';
import Vacancy from '@/components/vacancy/Vacancy';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns, Column, Heading, Page, Vacancy, AsideImage,
  },
  data () {
    return {
      imageBg: imageBg,
      allVacancies: [
        { title: 'Региональный Директор по развитию',
        description: 'Короткое описание. Короткое описание. Короткое описание.',
        url: '#' },
        { title: 'Региональный Директор по развитию',
        description: 'Короткое описание. Короткое описание. Короткое описание.',
        url: '#' },
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// Vacancies.vue?79a4c340